import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { defaultListPaginationParameters } from '../../../data-access';
import { ActionConfigFactory, ActionTypeEnum, ActionTypeHandlerEnum, IActionConfig } from '../../../ui';
import { CitiesApiClientProvider, ICitiesApiClient } from '../clients';
import { ICityResponse } from '../dtos';
import { CreateUpdateCityComponent } from '../../../../../trash/location-management/cities/components/create-update-city/create-update-city.component';
import { LocationManagementPermissions } from '../../common/permissions';
import { SoftDeletableAuditableTranslatableLookupsComponent } from "../../../lookups/components/soft-deletable-auditable-translatable-lookups/soft-deletable-auditable-translatable-lookups.component";

@Component({
  selector: 'app-cities',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableTranslatableLookupsComponent],
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.scss']
})
export class CitiesComponent {
  client: ICitiesApiClient = inject(CitiesApiClientProvider).getClient();
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  router = inject(Router);
  defualtPaginationParameters = defaultListPaginationParameters;

  supportedActions: IActionConfig<ICityResponse>[] = [
    ActionConfigFactory.createDialog(this.dialogService, {
      type: ActionTypeEnum.VIEW,
      componentType: CreateUpdateCityComponent,
      headerResolver: (x) => `${this.translate.instant('LOCATION_MANAGEMENT.CITY')} ${this.translate.currentLang === 'ar' ? `'${x!.arabicName}'` : `'${x!.englishName}'`
        }`,
      permission: LocationManagementPermissions.Cities.Read
    }),
    {
      type: ActionTypeEnum.CREATE,
      label: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.NEW_CITY')}`,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateCityComponent,
        configResolver: (item?: ICityResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.CITY')}`
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Cities.Create
    },
    {
      type: ActionTypeEnum.UPDATE,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateCityComponent,
        configResolver: (item?: ICityResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('LOCATION_MANAGEMENT.CITY')} ${this.translate.currentLang === 'ar' ? `'${item!.arabicName}'` : `'${item!.englishName}'`
            }`,
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Cities.Update
    }
  ];
}
